import { render, staticRenderFns } from "./ReportRvds.vue?vue&type=template&id=edd3d962"
import script from "./ReportRvds.vue?vue&type=script&lang=js"
export * from "./ReportRvds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports